/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_variant_faq1_a = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`It runs for exactly ${i?.label}. The timer starts when you type your first character and stops automatically when the time is up.`)
};

const es_typing_variant_faq1_a = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dura exactamente ${i?.label}. El cronómetro comienza cuando escribes tu primer carácter y se detiene automáticamente cuando se acaba el tiempo.`)
};

const de_typing_variant_faq1_a = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Er läuft genau ${i?.label} lang. Der Timer startet, sobald du das erste Zeichen tippst, und stoppt automatisch, wenn die Zeit abgelaufen ist.`)
};

const nl_typing_variant_faq1_a = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hij duurt precies ${i?.label}. De timer start zodra je je eerste teken typt en stopt automatisch als de tijd om is.`)
};

const fr_typing_variant_faq1_a = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il dure exactement ${i?.label}. Le chronomètre démarre lorsque vous tapez votre premier caractère et s'arrête automatiquement à la fin du temps imparti.`)
};

const it_typing_variant_faq1_a = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dura esattamente ${i?.label}. Il timer parte quando digiti il primo carattere e si ferma automaticamente allo scadere del tempo.`)
};

const pt_br2_typing_variant_faq1_a = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ele dura exatamente ${i?.label}. O cronômetro começa quando você digita o primeiro caractere e para automaticamente quando o tempo acaba.`)
};

const pt_typing_variant_faq1_a = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dura exatamente ${i?.label}. O cronómetro inicia quando escreve o primeiro carácter e para automaticamente quando o tempo termina.`)
};

const ja_typing_variant_faq1_a = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ちょうど${i?.label}間続きます。タイマーは最初の文字を入力した瞬間に始まり、時間が終了すると自動的に停止します。`)
};

const zh_typing_variant_faq1_a = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`测试正好持续${i?.label}。计时器会在您输入第一个字符时启动，时间结束后自动停止。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ label: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_variant_faq1_a = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_variant_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_variant_faq1_a", locale)
	if (locale === "en") return en_typing_variant_faq1_a(inputs)
	if (locale === "es") return es_typing_variant_faq1_a(inputs)
	if (locale === "de") return de_typing_variant_faq1_a(inputs)
	if (locale === "nl") return nl_typing_variant_faq1_a(inputs)
	if (locale === "fr") return fr_typing_variant_faq1_a(inputs)
	if (locale === "it") return it_typing_variant_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_typing_variant_faq1_a(inputs)
	if (locale === "pt") return pt_typing_variant_faq1_a(inputs)
	if (locale === "ja") return ja_typing_variant_faq1_a(inputs)
	return zh_typing_variant_faq1_a(inputs)
};